import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../../toastmsg";
import { scholarshipListingFields } from "../../../../formSchemas";
import UserForm from "../../../../Components/UserForm";

export default function AddScholarship() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddScholarship = async (formData: any) => {
    setLoading(true);
  };

  const handleCancel = () => {
    navigate("/scholarship-listing");
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Add New Scholarship</h2>
      {/* <UserForm
        fields={scholarshipListingFields}
        onSubmit={handleAddScholarship}
        onCancel={handleCancel}
        disabled={loading}
      /> */}
    </div>
  );
}
